import {EntityApiService, ApiClientService} from '@dofleini/security';
import {flatDataClients} from '../contants/mockup';
import {data} from '../contants/data';

class ClientsApiService extends EntityApiService {

  // searchInFilter = (params) => ApiClientService.post(this.getPath('/search'), {...params, filters: {...params?.filters, type: 'TERM', 'field':'active','value': true, 'objectId': false}});

    searchClients = (params) => ApiClientService.post(this.getPath('/parent/search'), params);

    search = (params) => ApiClientService.post(this.getPath('/search'), params);

    searchForUsers = (params) => ApiClientService.post(this.getPath('/search-for-users'), params);

    searchChildStructures = (params) => ApiClientService.post(this.getPath(`/${params?.parentId}/children`), params);

    getOneClient = ({clientId}, params) => {
      const config = {params};
      if (params?.projections && Array.isArray(params.projections)) {
        config.params = {
          ...params,
          projections: params.projections.join(',')
        };
      }
      return ApiClientService.get(this.getPath(`/${clientId}`), config);
    };

    getChildren = ({parentId, ...params}) => ApiClientService.post(this.getPath(`/${parentId}/children`), params);

    delete = ({_id}) => ApiClientService.delete(this.getPath(`/${_id}?cascadeDelete=true`));

    setStructureId = (currentId) => {
      localStorage.setItem('structure-current-id', currentId);
    }

    getStructureId = () => {
      return localStorage.getItem('structure-current-id');
    }

    /** Get Mockup Data */
    getMockupData = () => {
      return {data};
    };

    /** Get Mockup Data */
    getMockupFlatData = () => {
      return {data: flatDataClients};
    };

    /** Get Mockup Data */
    getMockupDirectoryData = () => {
      return {data: flatDataClients};
    };
}

export default new ClientsApiService('/ms-core/api/structures');
